package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.dashboard.softwareDevelopmentSection.SoftwareExperienceBox
import devxertech.com.pages.dashboard.softwareDevelopmentSection.createIntersectionObserver
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.document
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun MakeYourOwnTeam(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    var yearsNumber by remember { mutableStateOf(1) }
    var clientsNumber by remember { mutableStateOf(1) }
    var projectsNumber by remember { mutableStateOf(1) }
    var expertsNumber by remember { mutableStateOf(1) }
    var hourNumbers by remember { mutableStateOf(1) }
    var isVisible by remember { mutableStateOf(false) }
    val ctx = rememberPageContext()

    LaunchedEffect(Unit) {
        val targetElement = document.getElementById("experience-section")
        if (targetElement != null) {
            val observer = createIntersectionObserver {
                isVisible = true
            }
            observer.observe(targetElement)
        }
    }
    DisposableEffect(Unit) {
        val sectionElement = document.getElementById("experience-section")
        val observer = createIntersectionObserver { }

        sectionElement?.let {
            observer.observe(it)
        }
        onDispose {
            sectionElement?.let { observer.unobserve(it) }
        }
    }
    LaunchedEffect(isVisible) {
        if (isVisible) {
            launch {
                while (yearsNumber < 230) {
                    delay(6)
                    yearsNumber++ }
            }
            launch {
                while (clientsNumber < 350) {
                    delay(5)
                    clientsNumber++ }
            }
            launch {
                while (projectsNumber < 200) {
                    delay(10)
                    projectsNumber++ }
            }
            launch {
                while (expertsNumber < 200) {
                    delay(10)
                    expertsNumber++ }
            }
            launch {
                while (hourNumbers < 500) {
                    delay(3)
                    hourNumbers++ }
            }
        }
    }
    Column(modifier = Modifier.fillMaxWidth()) {
        Box(modifier = Modifier.fillMaxWidth().backgroundColor(sitePalette.teamSectionBackground.rgb),
            contentAlignment = Alignment.Center
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(top = 30.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(text = "LOOKING FOR DEDICATED App DEVELOPERS?",
                    modifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint < Breakpoint.MD) 15.px else 18.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.Medium)
                        .textAlign(TextAlign.Center)
                        .lineHeight(15.4.px)
                        .textTransform(TextTransform.Uppercase)
                        .padding(bottom = 5.px)
                )
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    val rowTextModifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                        .fontWeight(FontWeight.ExtraBold)
                        .textTransform(TextTransform.Uppercase)
                    Row(
                        modifier = Modifier.flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText(text = "Make Your ",
                            modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                                .letterSpacing(0.5.px))
                        SpanText(text = "Own Team",
                            modifier = rowTextModifier.color(sitePalette.primary.rgb)
                                .letterSpacing(0.5.px))
                    }
                }
//                if (window.screen.width in 1030..1439) {
//                    Row(modifier = Modifier
//                        .fillMaxWidth().margin(leftRight = 30.px, top = 20.px)
//                        .flexWrap(FlexWrap.Wrap),
//                        horizontalArrangement = Arrangement.SpaceEvenly,
//                    ) {
//                        SoftwareColumn(breakpoint = breakpoint,
//                            image = Res.Image.team_vector,
//                            overlappedImage = Res.Image.team_1,
//                            title = "Project-Based"
//                        )
//                        SoftwareColumn(breakpoint = breakpoint,
//                            image = Res.Image.team_vector,
//                            overlappedImage = Res.Image.team_2,
//                            title = "Developers Availability \n" +
//                                    "by Hours/Days") }
//                    Row(
//                        modifier = Modifier.fillMaxWidth().margin(leftRight = 30.px, top = 10.px)
//                            .flexWrap(FlexWrap.Wrap),
//                        horizontalArrangement = Arrangement.SpaceEvenly,
//                    ) {
//                        SoftwareColumn(breakpoint = breakpoint,
//                            image = Res.Image.team_vector,
//                            overlappedImage = Res.Image.team_3,
//                            title = "Hire a dedicated Team\n" +
//                                    "of Developers")
//                        SoftwareColumn(breakpoint = breakpoint,
//                            image = Res.Image.team_vector,
//                            overlappedImage = Res.Image.team_4,
//                            title = "More Customization?"
//                        )
//                    }
//                } else {
                    Row(modifier = Modifier
                        .fillMaxWidth(if (breakpoint == Breakpoint.LG) 80.percent else 100.percent)
                        .margin(leftRight = 30.px, top = 10.px, bottom = 20.px)
                        .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.Center,
                    ) {
                        SoftwareColumn(
                            breakpoint = breakpoint,
                            image = Res.Image.team_vector,
                            overlappedImage = Res.Image.team_1,
                            title = "Project-Based"
                        )
                        SoftwareColumn(
                            breakpoint = breakpoint,
                            image = Res.Image.team_vector,
                            overlappedImage = Res.Image.team_2,
                            title = "Developers Availability \n" +
                                    "by Hours/Days",
                            titleMarginTop = 20.px
                        )
                        SoftwareColumn(
                            breakpoint = breakpoint,
                            image = Res.Image.team_vector,
                            overlappedImage = Res.Image.team_3,
                            title = "Hire a dedicated Team\n" +
                                    "of Developers",
                            titleMarginTop = 20.px
                        )
                        SoftwareColumn(
                            breakpoint = breakpoint,
                            image = Res.Image.team_vector,
                            overlappedImage = Res.Image.team_4,
                            title = "More Customization?"
                        )
                    }
                    Box(modifier = Modifier.margin(bottom = 40.px).align(Alignment.CenterHorizontally)
                    ) { CommonButton(text = "Lets Talk", onClick = {
                        ctx.router.navigateTo("/contact-us")
                    }) }
            }
        }
        Column(
            modifier = Modifier.fillMaxWidth(
                if (breakpoint > Breakpoint.LG) 60.percent
                else if (breakpoint == Breakpoint.LG) 90.percent
                else if (breakpoint >= Breakpoint.MD) 80.percent
                else 85.percent)
                .align(Alignment.CenterHorizontally),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(modifier = Modifier.fillMaxWidth()
                .height(if (breakpoint >= Breakpoint.LG) 150.px else if (breakpoint <= Breakpoint.MD) 70.px else 57.px)
                .padding(left = if (breakpoint < Breakpoint.MD) 5.px else 0.px )
                .backgroundImage(url(Res.Image.software_bottom_sec))
                .backgroundSize(BackgroundSize.Cover)
                .backgroundPosition(BackgroundPosition.of(CSSPosition.Center)),
                contentAlignment = Alignment.Center
            )
            {
                Row(modifier = Modifier
                    .id("experience-section")
                    .fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    SoftwareExperienceBox("$yearsNumber+", "Apps Developed")
                    SoftwareExperienceBox("$clientsNumber+", "Apps Downloads")
                    SoftwareExperienceBox("$projectsNumber+", "Satisfied Clients")
                    SoftwareExperienceBox("$expertsNumber+", "Resources")
                    SoftwareExperienceBox("$hourNumbers+", "Hours Spent")
                }
            }
        }
    }
}

@Composable
fun SoftwareColumn(
    breakpoint: Breakpoint, image: String, title: String, overlappedImage: String? = null,
    titleMarginTop:  CSSLengthNumericValue = 0.px,
) {
    val sitePalette = ColorMode.current.toSitePalette()

    Column(modifier = Modifier.margin(top = 50.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(modifier = Modifier.width(320.px).height(151.px).border(1.px).zIndex(0)
        ) { Image(src = Res.Image.team_vector, modifier = Modifier.fillMaxSize())
            overlappedImage?.let {
                Image(src = it, modifier = Modifier
                    .size(80.px, 87.px)
                    .zIndex(1)
                    .align(Alignment.TopCenter)
                    .margin(top = (-22).px)) }
            Box(modifier = Modifier.align(Alignment.Center)
            ) {
                FieldTitleTextNormalSimple(
                    text = title,
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = 15.px,
                    textAlign = TextAlign.Center,
                    fontWeight = 600,
                    marginTop = titleMarginTop,
                    whiteSpace = WhiteSpace.PreWrap

                )
            }
        }
    }
}